import { render, staticRenderFns } from "./mail-edit-modal.vue?vue&type=template&id=09cb3c46&scoped=true&"
import script from "./mail-edit-modal.vue?vue&type=script&lang=js&"
export * from "./mail-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./mail-edit-modal.vue?vue&type=style&index=0&id=09cb3c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cb3c46",
  null
  
)

export default component.exports